"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const GameData_1 = require("../../../Shared/GameData");
class ShopSlot extends PIXI.Container {
    constructor() {
        super();
        this.bg = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.itemSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.quantityText = new PIXI.extras.BitmapText('', { font: 'gold2' });
        this.itemName = null;
        this._quantity = 0;
        this.addChild(this.bg);
        this.addChild(this.itemSprite);
        this.addChild(this.quantityText);
    }
    set texture(t) {
        this.itemSprite.texture = t;
        if (t) {
            if (t.width < this.bg.width) {
                this.itemSprite.x = (this.bg.width / 2) - (t.width / 2);
            }
            else {
                const diff = t.width - this.bg.width;
                this.itemSprite.x = diff / 2;
            }
            if (t.height < this.bg.height) {
                this.itemSprite.y = (this.bg.height / 2) - (t.height / 2);
            }
            else {
                const diff = t.height - this.bg.height;
                this.itemSprite.y = diff / 2;
            }
        }
    }
    get quantity() { return this._quantity; }
    set quantity(v) {
        this._quantity = v || 0;
        if (v && v > 1) {
            this.quantityText.text = `${v}`;
        }
        else {
            this.quantityText.text = '';
        }
    }
}
const SHOP_COLUMNS = 2;
const SHOP_ROWS = 2;
class ContextMenuOption extends PIXI.Container {
    constructor(option, callback) {
        super();
        this.bg = new PIXI.Sprite();
        this.callback = callback;
        this.addChild(this.bg);
        this.bg.y -= 3;
        this.bg.x -= 2;
        this.bitmapText = new PIXI.extras.BitmapText(option, { font: 'gold' });
        this.addChild(this.bitmapText);
    }
}
class ContextMenu extends PIXI.Container {
    constructor(bgTexture, selectedOptionTexture) {
        super();
        this.bg = new PIXI.Sprite();
        this.options = [];
        this.selectedOptionTexture = selectedOptionTexture;
        this.bg.texture = bgTexture;
        this.addChild(this.bg);
    }
    clear() {
        this.visible = false;
        this.options.forEach(o => {
            o.destroy();
        });
        this.options.length = 0;
    }
    setSelectedOption(index) {
        this.options.forEach((o, i) => {
            if (i === index) {
                o.bg.texture = this.selectedOptionTexture;
            }
            else {
                o.bg.texture = PIXI.Texture.EMPTY;
            }
        });
    }
    setOptions(options) {
        this.clear();
        this.visible = true;
        const space = (this.bg.height - 30) / options.length;
        this.options = options.map((o, i) => {
            const opt = new ContextMenuOption(o.action, o.callback);
            opt.y = (space * i) + 15;
            opt.x = 5;
            this.addChild(opt);
            return opt;
        });
    }
}
class ShopSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.SHOP);
        this.shopContainer = new PIXI.Container();
        this.shopSlots = [];
        this.curSelectedIndex = 0;
        this.timeSinceShopToggled = 1;
        this.timeSinceShopAction = 1;
        this.shopPointer = new PIXI.Sprite();
        this.recenterInterface = this.recenterInterface.bind(this);
        this.shopContainer.visible = false;
    }
    get isOpen() {
        return this.shopContainer.visible;
    }
    isShopOpen() {
        return this.shopContainer.visible;
    }
    get isItemMenuOpen() {
        return this.itemContextMenu.visible;
    }
    onClear() {
    }
    initShop() {
        GameData_1.ShopItemData.forEach(item => {
        });
    }
    handlePlayerHoneyUpdate(newHoneyAmount) {
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.PLAYER_HONEY_UPDATE:
                this.handlePlayerHoneyUpdate(message.data);
                break;
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.clientPlayer = message.data;
                break;
        }
    }
    openShop() {
    }
    onStart() {
        this.addApi(this.openShop);
        this.shopTextures = this.globals.gameTextures.inventory;
        this.itemIconTextures = this.globals.gameTextures.items.icons;
        this.shopPointer = new PIXI.Sprite();
        this.backgroundSprite = new PIXI.Sprite(this.shopTextures.background);
        this.shopContainer.addChild(this.backgroundSprite);
        const padX = 10;
        const slotW = (this.shopTextures.background.width - (padX * 2)) / SHOP_COLUMNS;
        const slotH = this.shopTextures.background.height / SHOP_ROWS;
        for (let row = 0; row < SHOP_ROWS; row++) {
            for (let col = 0; col < SHOP_COLUMNS; col++) {
                const slot = new ShopSlot();
                slot.x = (col * slotW) + padX + 2; // extra 2 padding since the left side of the interface texture is kind of wonky.
                slot.y = row * slotH + 5;
                if (col === 0 || col === 7) {
                    slot.y += 6;
                }
                if (col === 1 || col === 6) {
                    slot.y += 3;
                }
                if (row === 0) {
                    slot.y += 3;
                }
                else {
                    slot.y -= 3;
                }
                slot.bg.texture = this.shopTextures.item.emptyBackground;
                this.shopContainer.addChild(slot);
                this.shopSlots.push(slot);
            }
        }
        const options = [];
        this.itemContextMenu = new ContextMenu(this.shopTextures.contextMenu.background, this.shopTextures.contextMenu.selectedBackground);
        this.shopContainer.addChild(this.itemContextMenu);
        this.shopContainer.addChild(this.shopPointer);
        this.addApi(this.isShopOpen);
        this.setSelectedItemSlot(0);
        this.globals.tileWorld.interfaceManager.addChild(this.shopContainer);
        this.recenterInterface();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.recenterInterface);
        }
        else if (typeof document !== 'undefined') {
            document.addEventListener('resize', this.recenterInterface);
        }
        this.initShop();
    }
    removeShopSlot(slotIndex) {
        if (this.shopSlots[slotIndex].itemName) {
            this.shopSlots[slotIndex].bg.texture = this.shopTextures.item.emptyBackground;
            this.shopSlots[slotIndex].texture = PIXI.Texture.EMPTY;
            this.shopSlots[slotIndex].quantity = 0;
            this.shopSlots[slotIndex].itemName = null;
        }
    }
    updateShopSlot(slotIndex, itemName, totalQuantity) {
        this.removeShopSlot(slotIndex);
        const slot = this.shopSlots[slotIndex];
        slot.itemName = itemName;
        const texture = this.itemIconTextures[itemName];
        slot.texture = texture;
        slot.quantity = totalQuantity;
    }
    setSelectedItemSlot(slotIndex) {
        this.shopSlots[this.curSelectedIndex].bg.texture = this.shopTextures.item.emptyBackground;
        if (this.isItemMenuOpen) {
            this.hideItemOptions();
        }
        this.curSelectedIndex = slotIndex;
        this.shopSlots[slotIndex].bg.texture = this.shopTextures.item.selectedBackground;
        this.shopPointer.texture = this.shopTextures.item.pointer;
        this.shopPointer.x = this.shopSlots[slotIndex].x + 5;
        const slotH = this.shopTextures.item.emptyBackground.height;
        this.shopPointer.y = this.shopSlots[slotIndex].y + (slotH - 2);
    }
    toggleShop(show) {
        this.shopContainer.visible = show;
        this.shopPointer.texture = this.shopTextures.item.pointer;
        this.shopPointer.visible = show;
        this.timeSinceShopToggled = 0;
        if (!show) {
            this.itemContextMenu.visible = false;
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    get shopToggleIsCoolingDown() {
        return this.timeSinceShopToggled < .3;
    }
    get shopActionIsCoolingDown() {
        return (this.timeSinceShopAction < .3);
    }
    canDoShopInputAction(inputKey) {
        return !this.shopToggleIsCoolingDown && (!this.shopActionIsCoolingDown || !this.previousInput[inputKey]);
    }
    getValidMoveTo(input) {
        const { moveUp, moveDown, moveLeft, moveRight } = input;
        if (moveUp || moveDown || moveLeft || moveRight) {
            // same behavior for moveUp/moveDown since theres only 2 columns...
            if ((moveUp && this.canDoShopInputAction('moveUp')) || (moveDown && this.canDoShopInputAction('moveDown'))) {
                if (this.curSelectedIndex < SHOP_COLUMNS) {
                    return this.curSelectedIndex + SHOP_COLUMNS;
                }
                else {
                    return this.curSelectedIndex - SHOP_COLUMNS;
                }
            }
            else if (moveLeft && this.canDoShopInputAction('moveLeft')) {
                if (this.curSelectedIndex % SHOP_COLUMNS === 0) {
                    return this.curSelectedIndex + (SHOP_COLUMNS - 1);
                }
                else {
                    return this.curSelectedIndex - 1;
                }
            }
            else if (moveRight && this.canDoShopInputAction('moveRight')) {
                if ((this.curSelectedIndex + 1) % SHOP_COLUMNS === 0) {
                    return this.curSelectedIndex - (SHOP_COLUMNS - 1);
                }
                else {
                    return this.curSelectedIndex + 1;
                }
            }
        }
        return -1;
    }
    get currentSelectedItemSlot() {
        return this.shopSlots[this.curSelectedIndex];
    }
    get currentSelectedItemData() {
        const { itemName, quantity } = this.shopSlots[this.curSelectedIndex];
        if (itemName) {
            return {
                globalData: GameData_1.GlobalGameData.items[itemName],
                shopData: { index: this.curSelectedIndex, name: itemName, quantity },
            };
        }
        return null;
    }
    showItemOptions() {
        if (!this.currentSelectedItemData)
            return false;
        this.itemContextMenu.visible = true;
        this.itemContextMenu.x = this.currentSelectedItemSlot.x + this.currentSelectedItemSlot.bg.width - 3;
        this.itemContextMenu.y = this.currentSelectedItemSlot.y + (this.currentSelectedItemSlot.bg.height) - 10;
        const type = this.currentSelectedItemData.globalData.type;
        const opts = [{
                action: 'buy',
                callback: () => {
                }
            }];
        this.shopPointer.texture = this.shopTextures.contextMenu.pointer;
        this.itemContextMenu.setOptions(opts);
        this.setCurrentSelectedItemOption(0);
        return true;
    }
    hideItemOptions() {
        this.itemContextMenu.clear();
        this.setSelectedItemSlot(this.curSelectedIndex);
    }
    setCurrentSelectedItemOption(index) {
        this.currentSelectedItemOptionIndex = index;
        this.itemContextMenu.setSelectedOption(index);
        if (this.itemContextMenu.options[index]) {
            this.shopPointer.x = this.itemContextMenu.x - (this.shopPointer.width / 2 + 7);
            this.shopPointer.y = this.itemContextMenu.y + this.itemContextMenu.options[index].y;
        }
    }
    get currentSelectedItemOptionText() {
        if (this.itemContextMenu.visible) {
            // @ts-ignore
            return this.itemContextMenu.children[this.currentSelectedItemOptionIndex].children[1].text;
        }
        return null;
    }
    recenterInterface() {
        /*
        const { ratioW, ratioH } = this.globals.tileWorld.playerCamera;
        const centerX = (window.innerWidth / 2) - ((this.shopTextures.background.width / ratioW)/2);
        const centerY = (window.innerHeight / 2) - ((this.shopTextures.background.height / ratioH)/2);
        const { x, y } = this.globals.tileWorld.playerCamera.screenToWorld(centerX, centerY)
        this.shopContainer.x = x-this.globals.tileWorld.playerCamera.playerViewRect.x;
        this.shopContainer.y = y-this.globals.tileWorld.playerCamera.playerViewRect.y;

         */
        const screenWidth = this.globals.renderer.screen.width;
        const screenHeight = this.globals.renderer.screen.height;
        this.shopContainer.x = (screenWidth / 2) - (this.shopTextures.background.width / 2);
        this.shopContainer.y = (screenHeight / 2) - (this.shopTextures.background.height / 2);
    }
    doMoveSelectedItemOption(up, down) {
        if (down) {
            if (this.currentSelectedItemOptionIndex === this.itemContextMenu.options.length - 1) {
                this.setCurrentSelectedItemOption(0);
            }
            else {
                this.setCurrentSelectedItemOption(this.currentSelectedItemOptionIndex + 1);
            }
        }
        else if (up) {
            if (this.currentSelectedItemOptionIndex === 0) {
                this.setCurrentSelectedItemOption(this.itemContextMenu.options.length - 1);
            }
            else {
                this.setCurrentSelectedItemOption(this.currentSelectedItemOptionIndex + 1);
            }
        }
    }
    onStop() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.recenterInterface);
        }
        else if (typeof document !== 'undefined') {
            document.removeEventListener('resize', this.recenterInterface);
        }
    }
    get curSelectedOptionCallback() {
        if (this.itemContextMenu.visible && this.itemContextMenu.options[this.currentSelectedItemOptionIndex]) {
            return this.itemContextMenu.options[this.currentSelectedItemOptionIndex].callback;
        }
        return () => { };
    }
    update(delta) {
        if (!this.$api.gameStateInitialized() || !this.clientPlayer)
            return;
        const { grab, moveDown, moveUp, cancel, escape } = this.clientPlayer.playerInput;
        this.timeSinceShopToggled += delta;
        this.timeSinceShopAction += delta;
        if (this.isItemMenuOpen) {
            if (grab && this.canDoShopInputAction('grab')) {
                this.curSelectedOptionCallback();
                this.timeSinceShopAction = 0;
            }
            else if ((moveDown && this.canDoShopInputAction('moveDown')) || (moveUp && this.canDoShopInputAction('moveUp'))) {
                this.doMoveSelectedItemOption(moveUp && this.canDoShopInputAction('moveUp'), moveDown && this.canDoShopInputAction('moveDown'));
                this.timeSinceShopAction = 0;
            }
            else if (cancel && this.canDoShopInputAction('cancel')) {
                this.hideItemOptions();
                this.timeSinceShopAction = 0;
            }
        }
        else if (this.isOpen) {
            const moveTo = this.getValidMoveTo(this.clientPlayer.playerInput);
            if (moveTo > -1) {
                this.setSelectedItemSlot(moveTo);
                this.timeSinceShopAction = 0;
            }
            else if (grab && this.canDoShopInputAction('grab')) {
                const showed = this.showItemOptions();
                if (showed)
                    this.timeSinceShopAction = 0;
            }
            else if (cancel && this.canDoShopInputAction('cancel')) {
                this.toggleShop(false);
                this.timeSinceShopAction = 0;
            }
        }
        this.previousInput = Object.assign({}, this.clientPlayer.playerInput);
    }
}
exports.ShopSystem = ShopSystem;
//# sourceMappingURL=module.js.map